// @flow
import makeRenderer from './RenderedIconInstance';
export default makeRenderer('CppPlatform/Extensions/primitivedrawingicon.png');
